export const JOB_STATUS = {
  U: 'UnKnown',
  C: 'Complete',
  D: 'Deleted',
  E: 'Estimated',
  F: 'Final',
  I: 'Inactive',
  L: 'Lost',
  O: 'Open',
  N: 'Negotiating',
};

export const PT_CATEGORY = {
  barrierCable: 'Barrier Cable',
  cable: 'Cable',
  ptHardware: 'PT Hardware',
  accessories: 'Accessories',
  studRails: 'Stud Rails',
};

export const CUT_STATUS = {
  draft: 1,
  releaseToShop: 2,
  dateApproved: 3,
  tagged: 4,
  sentToTMW: 5,
  WIP: 6,
  shipped: 7,
  inProduction: 8,
};

export const PRODUCTION_STATUS = CUT_STATUS;

export const REPORT_NAMES = {
  loadSummary: 'Load Summary',
  looseComponents: 'Loose Components',
  fabOrder: 'Fab Order',
  tag: 'Tag',
  studrailPaperwork: 'Studrail Paperwork',
  looseComponentsDetailed: 'Loose Components Detailed',
  ptiPaperwork: 'PTI Paperwork',
  barrierCableFabOrder: 'Barrier Cable Fab Order Report',
  exportToProd : 'Export to Prod'
};

export const LOAD_TYPE = {
  cable: 1,
  studRails: 2,
};

export const AREA_NAMES = {
  pt: 'PT',
  rebar: 'Rebar',
  projections: 'Projections',
  detailingTimeEntry: 'Detailing Time Entry',
  submittals: 'Submittals',
};

export const BID_ITEMS = {
  ptCable: 1,
  barrierCable: 2,
  studRails: 3,
  ptAccessories: 4,
  equipment: 5,
  engineering: 6,
  restoration: 7,
  stressing: 8,
  labor: 9,
};
export const DELIVERY_TYPES = {
  jobsite: 1,
  willCall: 2,
  stoYard: 3,
  other: 4,
};

export const SUBMITTALS_STATUS_DESCRIPITION = {
  Scheduled: 'Scheduled',
  Submitted: 'Submitted',
  Revised: 'Revised',
  Approved: 'Approved',
  Waived: 'Waived',
};

export const SUBMITTALS_STATUS = {
  'Scheduled': 1,
  'SubmittedForApproval': 2,
  'ReviseAndResubmit': 3,
  'ReturnedApproved': 4,
  'Waived': 5,
  'Issued for Construction': 6
}; 

export const MODULE_NAME = {
  postTension: 'Post Tension',
  projections: 'Projections',
  submittals: 'Submittals',
  detailingTimeEntry: 'Detailing Time Entry',
  admin: 'Admin',
  reports: 'Reports',
  disptch: 'Dispatch',
  broadcast: 'Brodcast',
  timeManagement: 'Time Management',
  coc: 'COC',
  approvals: 'Approvals',
  scheduledSubmittals: 'Sched. Submittals',
  messages: 'Messages',
};

export const PART_CLASS_ID = {
  railPartClassId: 5,
  studPartClassId: 4,
};

export const JOB_DETAILING_TYPE = {
  ListingOnly: 3,
};

export const OPERATION_STATUS = {
  InProgress: 1,
  Completed: 2,
  Failed: 3,
  Cancelled: 4,
};
